import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const marketData = [
  { symbol: 'NIFTY 50', value: '22,456.80', change: '+1.23%', up: true },
  { symbol: 'SENSEX', value: '73,876.54', change: '+0.89%', up: true },
  { symbol: 'BANK NIFTY', value: '48,234.15', change: '-0.45%', up: false },
  { symbol: 'S&P 500', value: '5,234.56', change: '+0.67%', up: true },
  { symbol: 'NASDAQ', value: '16,543.21', change: '+1.12%', up: true },
  { symbol: 'DOW JONES', value: '39,876.43', change: '-0.23%', up: false },
  { symbol: 'FTSE 100', value: '8,234.67', change: '+0.34%', up: true },
  { symbol: 'USD/INR', value: '83.45', change: '+0.12%', up: true },
  { symbol: 'GOLD', value: '$2,345.67', change: '+0.56%', up: true },
  { symbol: 'CRUDE OIL', value: '$78.90', change: '-1.02%', up: false },
  { symbol: 'BITCOIN', value: '$67,890', change: '+2.34%', up: true },
];

const MarketTicker = () => {
  return (
    <div className="ticker-wrap py-3 overflow-hidden">
      <div className="ticker flex items-center gap-8 whitespace-nowrap">
        {/* Duplicate for seamless loop */}
        {[...marketData, ...marketData].map((item, index) => (
          <div 
            key={`${item.symbol}-${index}`} 
            className="flex items-center gap-3 px-4"
          >
            <span className="font-semibold text-secondary-foreground/90">
              {item.symbol}
            </span>
            <span className="text-secondary-foreground">
              {item.value}
            </span>
            <span className={`flex items-center gap-1 font-medium ${
              item.up ? 'text-success' : 'text-destructive'
            }`}>
              {item.up ? (
                <TrendingUp className="w-4 h-4" />
              ) : (
                <TrendingDown className="w-4 h-4" />
              )}
              {item.change}
            </span>
            <span className="w-1 h-1 rounded-full bg-secondary-foreground/30 ml-2"></span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketTicker;
